import { gql } from '@apollo/client';

export const getEmployeeFunctions = gql`
  query getEmployeeFunctions {
    employeeFunctions(filter: { state: { _eq: ACTIVE } }) {
      totalCount
      edges {
        node {
          id
          oid
          name
        }
      }
    }
  }
`;
